// src/MapComponent.js
import React from 'react';
import { Map, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Set the default icon for markers
const defaultIcon = L.icon({
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
  shadowSize: [41, 41],
});

// Assign the default marker icon to all markers
L.Marker.prototype.options.icon = defaultIcon;

const MapComponent = ({ center = { lat: 50.075172019694584, lng: 14.450660048824602 }, height, zoom, officeData } ) => {
  const isSingleOffice = !Array.isArray(officeData.data);
  const hasOffices = Array.isArray(officeData.data) && officeData.data.length > 0;
  
  console.log(isSingleOffice, hasOffices, officeData)

  return (
    <Map center={isSingleOffice ? [officeData.data.lat, officeData.data.lon] : [center.lat, center.lng]} zoom={zoom} style={{ height: height, width: '100%' }}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      {/* Conditionally render markers based on data presence */}
      {hasOffices && officeData.data.map(office => (
        <Marker key={office.id} position={[office.lat, office.lon]}>
          <Popup>
            <div>
              <strong>{office.pub_server_name}</strong><br />
              {office.server_address}<br />
              {office.place_additional_info}
            </div>
          </Popup>
        </Marker>
      ))}
      {/* If officeData is a single office object, display that marker */}
      {isSingleOffice && (
        <Marker key={officeData.data.id} position={[officeData.data.lat, officeData.data.lon]}>
          <Popup>
            <div>
              <strong>{officeData.data.pub_server_name}</strong><br />
              {officeData.data.server_address}<br />
              {officeData.data.place_additional_info}
            </div>
          </Popup>
        </Marker>
      )}
    </Map>
  );
};

export default MapComponent;